export const API_URL = "https://recards-backend-ngtrh.ondigitalocean.app";
